function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m211.2 147.4c0 6.6-5.4 12-12 12h-188.4c-6.6 0-12-5.4-12-12v-135.4c0-6.6 5.4-12 12-12h188.4c6.6 0 12 5.4 12 12z",
  fill: "#bbbdbf"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m1 30.3v113.1c0 6.6 5.2 12 11.7 12h184.6c6.5 0 11.7-5.4 11.7-12v-113.1z",
  fill: "#f1f1f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m18.2 14.5c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.3 5 5z",
  fill: "#ec1c24"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m33.6 14.5c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.3 5 5z",
  fill: "#faaf40"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m49.1 14.5c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5c2.7 0 5 2.3 5 5z",
  fill: "#8bc53f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m45.8 75.9h118.3v10.7h-118.3z",
  fill: "#929497"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m61.1 92.5h87.9v10.7h-87.9z",
  fill: "#929497"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  stroke: "#6d6e70",
  strokeMiterlimit: 10,
  strokeWidth: 0.1422
}, /*#__PURE__*/React.createElement("path", {
  d: "m14 41h35.8v19h-35.8z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "m14 41 35.8 19"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 60 35.8-19"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#929497"
}, /*#__PURE__*/React.createElement("path", {
  d: "m144.8 49.1h14.6v2.7h-14.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m163.3 49.1h14.6v2.7h-14.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m181.9 49.1h14.6v2.7h-14.6z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m148.1 16c0 2.6-2.1 4.8-4.8 4.8h-76.5c-2.6 0-4.8-2.1-4.8-4.8v-2.6c0-2.6 2.1-4.8 4.8-4.8h76.5c2.6 0 4.8 2.1 4.8 4.8z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m203 16c0 2.6-2.1 4.8-4.8 4.8h-2.6c-2.6 0-4.8-2.1-4.8-4.8v-2.6c0-2.6 2.1-4.8 4.8-4.8h2.6c2.6 0 4.8 2.1 4.8 4.8z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m126.7 138.7h-43.4c-5.8 0-10.6-4.8-10.6-10.6s4.8-10.6 10.6-10.6h43.4c5.8 0 10.6 4.8 10.6 10.6 0 5.9-4.7 10.6-10.6 10.6z",
  fill: "#eb008b"
});

var SvgWhiteLabelScreen = function SvgWhiteLabelScreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 210 159.3",
    viewBox: "0 0 210 159.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteLabelScreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-label-screen.f11959f2.svg";
export { ForwardRef as ReactComponent };